export const defaultCntcMethNo = {
    UCTC010 : '',
    UCTC020 : '',
    UCTC030 : '',
    UCTC040 : '',
    UCTC050 : '',
    UCTC060 : ''
};

export const evtType = [
    {
        notiEvtCnfgNo: 10002,
        evtTypeCd: 'EVTTY010',
        cndRuleTrgtNo: null,
        cndRuleTrgtCd: 'CNDRLT10',
    },
    {
        notiEvtCnfgNo: 10003,
        evtTypeCd: 'EVTTY020',
        cndRuleTrgtNo: 10002,
        cndRuleTrgtCd: 'CNDRLT20',
    },
    {
        notiEvtCnfgNo: 10003,
        evtTypeCd: 'EVTTY020',
        cndRuleTrgtNo: 10003,
        cndRuleTrgtCd: 'CNDRLT20',
    },
    {
        notiEvtCnfgNo: 10004,
        evtTypeCd: 'EVTTY030',
        cndRuleTrgtNo: null,
        cndRuleTrgtCd: 'CNDRLT10',
    }

];

//담당자지정
export const EVTTY010 = {
    notiEvtCnfgNo: 10002,
    evtTypeCd: 'EVTTY010',
    cndRuleTrgtNo: null,
    cndRuleTrgtCd: 'CNDRLT10',
};

//확인
export const EVTTY020A = {
    notiEvtCnfgNo: 10003,
    evtTypeCd: 'EVTTY020',
    cndRuleTrgtNo: 10002,
    cndRuleTrgtCd: 'CNDRLT20',
};

//종료
export const EVTTY020C = {
    notiEvtCnfgNo: 10003,
    evtTypeCd: 'EVTTY020',
    cndRuleTrgtNo: 10003,
    cndRuleTrgtCd: 'CNDRLT20',
};

//에스컬레이션
export const EVTTY030 = {
    notiEvtCnfgNo: 10004,
    evtTypeCd: 'EVTTY030',
    cndRuleTrgtNo: null,
    cndRuleTrgtCd: 'CNDRLT10',
};

//인시던트생성
export const EVTTY040 = {
    notiEvtCnfgNo: 10001,
    evtTypeCd: 'EVTTY040',
    cndRuleTrgtNo: null,
    cndRuleTrgtCd: 'CNDRLT10',
};


export class LineConfigService {
    private config = {
      localhost: { lineChannelNumber: '634ztgvb' },
      deveks: { lineChannelNumber: '634ztgvb' },
      prdeks: { lineChannelNumber: '792wcdal' },
      'sec-prd-eks': { lineChannelNumber: '903usqev' },
    };
  
    getLineChannelNumber(): string {
      const env = process.env.NODE_ENV;
      return this.config[env].lineChannelNumber;
    }
  }



// WEBPACK FOOTER //
// ./src/app/views/main/personalsetting/my-infomation/my-infomation.config.ts